var _style, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGraphic = function SvgGraphic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgGraphic",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgGraphic{fill:#B5B5B5;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    className: "svgGraphic svgBase svgHover svgSelect",
    d: "M19.4,17H2.2V1.4c0-0.1-0.1-0.2-0.2-0.2h0H0.6c-0.1,0-0.2,0.1-0.2,0.2v0v17.2 c0,0.1,0.1,0.2,0.2,0.2h0h18.8c0.1,0,0.2-0.1,0.2-0.2l0,0v-1.4C19.6,17.1,19.5,17,19.4,17C19.4,17,19.4,17,19.4,17z M4.4,15h1.4 C5.9,15,6,14.9,6,14.8l0,0v-3.6C6,11.1,5.9,11,5.8,11h0H4.4c-0.1,0-0.2,0.1-0.2,0.2l0,0v3.6C4.2,14.9,4.3,15,4.4,15L4.4,15z M8.2,15 h1.4c0.1,0,0.2-0.1,0.2-0.2l0,0v-8c0-0.1-0.1-0.2-0.2-0.2l0,0H8.2C8.1,6.6,8,6.7,8,6.8l0,0v8C8,14.9,8.1,15,8.2,15 C8.2,15,8.2,15,8.2,15L8.2,15z M12,15h1.4c0.1,0,0.2-0.1,0.2-0.2l0,0V8.7c0-0.1-0.1-0.2-0.2-0.2l0,0H12c-0.1,0-0.2,0.1-0.2,0.2l0,0 v6.1C11.8,14.9,11.9,15,12,15C12,15,12,15,12,15L12,15z M15.8,15h1.4c0.1,0,0.2-0.1,0.2-0.2l0,0v-10c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.4 c-0.1,0-0.2,0.1-0.2,0.2l0,0v10C15.6,14.9,15.7,15,15.8,15C15.8,15,15.8,15,15.8,15L15.8,15z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGraphic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/graphic.aa4a7b9a.svg";
export { ForwardRef as ReactComponent };